/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface RetentionIn {
  /**
     * @minimum 30
     * @maximum 3650
     */
  regulated_recording_days: number;
  /**
     * @minimum 30
     * @maximum 3650
     */
  regulated_transcript_days: number;
  /**
     * @minimum 30
     * @maximum 3650
     */
  business_days: number;
  justification?: string | null;
}
